import {
  DialogBackdrop,
  DialogPanel,
  Dialog as HeadlessuiDialog,
} from '@headlessui/react';
import appHelpers from 'utils/app-urls';

import clsx from 'clsx';
import { ReactNode } from 'react';

const cdnURL = appHelpers.getCDNUrl();
const closeImg = `${cdnURL}assets/navigation/close.svg`;

export function Dialog({
  children,
  onClose,
  isOpen = true,
  backgroundColor = '#0C1C2C',
  dismissable = true,
  blurEnabled = false,
  isAuthenticated = true,
}: {
  children: ReactNode;
  onClose?: () => void;
  isOpen?: boolean;
  backgroundColor?: string;
  dismissable?: boolean;
  blurEnabled?: boolean;
  isAuthenticated?: boolean;
}) {
  return (
    <HeadlessuiDialog
      open={isOpen}
      className="relative z-50"
      onClose={() => onClose?.()}>
      <DialogBackdrop
        className={clsx(
          'fixed inset-0 bg-[#303243]',
          blurEnabled ? 'opacity-80' : 'opacity-100',
        )}
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel
          style={{ backgroundColor: backgroundColor }}
          className={clsx(
            'w-full max-w-[600px] flex flex-col max-h-full space-y-4 rounded-2xl p-6 relative overflow-scroll',
            isAuthenticated && 'xl:ml-64',
          )}>
          {dismissable && (
            <div className="absolute right-4 top-4">
              <img
                onClick={() => onClose?.()}
                src={closeImg}
                alt="close"
                className="ml-auto cursor-pointer"
              />
            </div>
          )}
          {children}
        </DialogPanel>
      </div>
    </HeadlessuiDialog>
  );
}
